<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`${activeId ? '编辑' : '新增'}检测项目`"
    width="900px"
    height="700px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="检测项目" prop="itemName">
            <el-input v-model.trim="editForm.itemName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测项目编码" prop="itemCode">
            <el-input v-model.trim="editForm.itemCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测项目类型" prop="itemType">
            <el-select v-model="editForm.itemType" placeholder="请选择">
              <el-option v-for="item in itemTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测标准" prop="basisNameTest">
            <el-input v-model.trim="editForm.basisNameTest" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="质量标准" prop="basisNameQl">
            <el-input type="textarea" v-model="editForm.basisNameQl" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="技术指标" prop="tiText">
            <el-input type="textarea" v-model="editForm.tiText" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="厚度要求" prop="remark">
            <el-input v-model.trim="editForm.remark" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="关联检测依据">
            <el-table border :data="basisList" height="200" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
              <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
              <el-table-column
                prop="basisName"
                label="依据的标准名称及编号（含年号）"
                min-width="180"
                header-align="center"
              ></el-table-column>
              <el-table-column prop="fileName" label="关联文件" align="center">
                <template v-slot="{ row }">
                  {{ row.fileName }}
                </template>
              </el-table-column>
              <el-table-column align="center" width="80">
                <template slot="header">
                  <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="handleBasisAdd"></el-button>
                </template>
                <template v-slot="{ row, $index }">
                  <el-popconfirm title="确定要删除此条记录吗？" @confirm="handleBasisDel($index)">
                    <el-button slot="reference" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="handleSubmit">确 认</el-button>
    </template>

    <!-- 检测依据选择弹窗 -->
    <BasisSelect
      :visible.sync="basisVisible"
      :selectTitle="`检测项目：${editForm.itemName}`"
      :checkedList="basisList"
      @setBasisList="setBasisList"
    />
  </drag-dialog>
</template>

<script>
import BasisSelect from '@/views/system/testBasis/components/BasisSelect';

import { getItem, editItem } from '@/api/system';

export default {
  components: { BasisSelect },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      editForm: {
        itemName: ''
      },
      basisList: [],
      itemTypeOptions: [
        {
          label: '样品类',
          value: 0
        },
        {
          label: '方法类',
          value: 1
        }
      ],
      rules: {
        itemName: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      basisVisible: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      const { data } = await getItem({ id: this.activeId });

      this.editForm = {
        id: data.id,
        itemName: data.itemName,
        itemCode: data.itemCode,
        unitPrice: data.unitPrice,
        oriVersion: data.oriVersion,
        itemType: data.itemType,
        basisNameTest: data.basisNameTest,
        basisNameQl: data.basisNameQl,
        tiText: data.tiText,
        remark: data.remark
      };
      this.basisList = data.basisList ?? [];
    },
    // 检测依据
    handleBasisAdd() {
      this.basisVisible = true;
    },
    handleBasisDel(index) {
      this.basisList.splice(index, 1);
    },
    setBasisList(val) {
      this.basisList = val;
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const basisList = this.basisList.map(item => {
            return {
              basisId: item.basisId
            };
          });
          const params = { ...this.editForm, basisList };
          try {
            await editItem(params);
            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}

.el-button--mini.is-circle {
  padding: 5px;
}
</style>
